import { useEffect, useState, useMemo } from 'react'
import classes from './SortingOptions.module.scss'
import CustomDropdown from '@/components/Sections/ProductReviews/CustomDropdown'
import { useMediaQuery } from 'react-responsive'
import SortIcon from '../Components/Icons/SortIcon'

export const SORT_OPTIONS = [
  { value: 'sale-bestseller', label: '-' },
  { value: 'price-low', label: 'Price: Low to High' },
  { value: 'price-high', label: 'Price: High to Low' }
]

const SortingOptions = ({ sortOption, onSortChange }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    if (!sortOption) {
      onSortChange(SORT_OPTIONS[0].value)
    }
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1073)
    }

    handleResize()
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const selectedOption = SORT_OPTIONS.find((option) => option.value === sortOption)

  if (isMobile) {
    return (
      <div className={classes.sortWrapper}>
        <button
          className={classes.mobileButton}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>Sort by: {selectedOption?.label || '-'}</span>
          <SortIcon />
        </button>

        <ul className={`${classes.mobileDropdown} ${isOpen ? classes.open : ''}`}>
          {SORT_OPTIONS.map((option) => (
            <li
              key={option.value}
              className={`${classes.option} ${option.value === selectedOption?.value ? classes.selected : ''}`}
              onClick={() => {
                onSortChange(option.value)
                setIsOpen(false)
              }}
            >
              {option.label}
            </li>
          ))}
        </ul>
      </div>
    )
  }

  return (
    <div className={classes.sorting}>
      <span className={classes.sortingLabel}>Sort by:</span>
      <CustomDropdown
        options={SORT_OPTIONS}
        selectedValue={selectedOption?.label || SORT_OPTIONS[0].label}
        onSelect={onSortChange}
      />
    </div>
  )
}

export default SortingOptions